import { apiService } from "@/_services";
import { formatDate_YMD } from "@/_core/_helpers/_helpers";
import { timeParse } from "d3";

/**
 * Fetches the latest currency forecasts and updates the component state.
 *
 * @param {object} _this - Context variables (state management for the component).
 */
export function getCurncyForecast(_this) {
  // Set loading state to indicate data fetching is in progress
  Object.assign(_this.loading, { forecastCurrencies: true });

  // API request parameters
  const params = {
    method: "GET",
    endpoint: "currency_fcst",
    content_type: "application/json",
    query_params: {
      date: formatDate_YMD(new Date()), // Format current date for API request
      format: "json"
    }
  };

  // Perform API request to fetch currency forecasts
  apiService
    .getAll(params)
    .then(data => {
      parseData(_this, data); // Process and update state with fetched data
    })
    .catch(error => {
      console.error("Error fetching currency forecasts:", error);
      Object.assign(_this.loading, { forecastCurrencies: false }); // Reset loading state
    });
}
/**
 * Parses the fetched currency forecast data and updates the state.
 *
 * @param {object} _this - Context variables (state management for the component).
 * @param {Array} data - Array of forecast data returned from the API.
 */
function parseData(_this, data) {
  // Extract unique currencies from the data
  let currencyList = data.map(d => ({ pk: d.pk, name: d.name }));
  currencyList = [
    ...new Map(currencyList.map(item => [item.name, item])).values()
  ];

  // Map currency forecasts to the expected structure
  const forecastData = data.map(d => ({
    update_date: timeParse("%Y-%m-%d")(d.update_date),
    date: timeParse("%Y-%m-%d")(d.objective_date),
    pk: d.pk,
    name: d.name,
    institution: d.institution,
    mean: d.mean
  }));

  // Create a mapping of currency primary keys (pk) to names
  const currencyByPk = data.reduce((acc, d) => {
    acc[d.pk] = d.name;
    return acc;
  }, {});

  // Update the component state with parsed data
  Object.assign(_this.data, {
    currencyList,
    forecastCurrencies: forecastData,
    currencyByPk
  });
  Object.assign(_this.loading, { forecastCurrencies: false }); // Reset loading state
}
